var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar-menu"},[_c('div',{staticClass:"extended-hover-zone"}),_c('div',{staticClass:"bar-menu-items",style:({ 
      width: _vm.width+'px',
      minWidth: _vm.width+'px',
      maxHeight: _vm.height+'px',
      overflow: _vm.height ? 'auto' : 'visible'
    })},_vm._l((_vm.menu),function(item,index){return _c(_vm.get_component(item.is),{key:'menu-'+index,tag:"component",class:item.class,attrs:{"item":item,"id":item.id}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }